import { render, staticRenderFns } from "./runSheetAssessorTab.vue?vue&type=template&id=6c6a0c7f&scoped=true"
import script from "./runSheetAssessorTab.vue?vue&type=script&lang=js"
export * from "./runSheetAssessorTab.vue?vue&type=script&lang=js"
import style0 from "./runSheetAssessorTab.vue?vue&type=style&index=0&id=6c6a0c7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6a0c7f",
  null
  
)

export default component.exports